// Search-state for the contacts index route. A thin instance of the shared
// resource list-page router-search factory; the route in contacts.routes.tsx
// owns the validateSearch schema via parseContactsSearch.
//
// Contacts keeps a direction even without an active sort (historical
// behaviour), so requireSortForDirection is left off.

import { DEFAULT_PAGE_SIZE } from '@components/DataTable/constants';
import {
  createResourceRouterSearch,
  createResourceSearchParser,
  type ResourceListSearchParams,
  type ResourceSortDirection,
} from '@hooks/resourceListPage';

type ContactSortColumnValue =
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'organisation_name'
  | 'created_at'
  | 'updated_at';

export type ContactSortColumn = ContactSortColumnValue | '';
export type ContactSortDirection = ResourceSortDirection;
export type ContactsSearchParams = ResourceListSearchParams<ContactSortColumnValue>;

// Default the list to name A→Z (the backend's contacts index defaults to the
// same first_name asc, so the SSR-seeded first page matches).
export const CONTACTS_SEARCH_DEFAULTS: ContactsSearchParams = {
  q: '',
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
  sort: 'first_name',
  direction: 'asc',
};

const CONTACT_SORT_COLUMNS: ReadonlyArray<ContactSortColumnValue> = [
  'first_name',
  'last_name',
  'email',
  'organisation_name',
  'created_at',
  'updated_at',
];

// validateSearch handler — coerces unknown URL input into the typed shape.
export const parseContactsSearch = createResourceSearchParser<ContactSortColumnValue>({
  defaults: CONTACTS_SEARCH_DEFAULTS,
  validSorts: CONTACT_SORT_COLUMNS,
});

export const useContactRouterSearch = createResourceRouterSearch<ContactSortColumnValue>('/contacts');
